"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validPw = exports.validOverseas = exports.validHeadNum = exports.validEmpty = exports.validCode = exports.validChs = exports.validAlphaOverseas = exports.validAlpha = exports.validAccountMerge = exports.validAccount = exports.handleValid = exports.VALID_RULES = exports.REGEX_PW = exports.REGEX_NUM = exports.REGEX_HEAD_NUM = exports.REGEX_CODE = exports.REGEX_CHS = exports.REGEX_ALPHA = exports.REGEX_ACCOUNT_OVERSEAS = exports.REGEX_ACCOUNT_MERGE = exports.REGEX_ACCOUNT = exports.PW_RULES = exports.CODE_RULES = exports.CODE_ACCOUNT_RULES = exports.ACCOUNT_RULES_OVERSEAS = exports.ACCOUNT_RULES = void 0;
/*
 * @Author: liujunhong
 * @Date: 2022/10/18
 * @Desc: 校验相关
 */
// 数字
var REGEX_HEAD_NUM = /\d/;
// 数字以1或者2开头
exports.REGEX_HEAD_NUM = REGEX_HEAD_NUM;
var REGEX_NUM = /^1\d{10}$/;
// 字母
exports.REGEX_NUM = REGEX_NUM;
var REGEX_ALPHA = /^[A-Za-z]+$/;
// 中文
exports.REGEX_ALPHA = REGEX_ALPHA;
var REGEX_CHS = /[\u4e00-\u9fa5]/g;
// 账号
exports.REGEX_CHS = REGEX_CHS;
var REGEX_ACCOUNT = /^(?!wg_)[a-zA-Z](?=(?:[^_]*_){0,3}[^_]*$)[\w\d_]{4,17}$/;
exports.REGEX_ACCOUNT = REGEX_ACCOUNT;
var REGEX_ACCOUNT_OVERSEAS = /^\w{5,18}$/;
// 密码
exports.REGEX_ACCOUNT_OVERSEAS = REGEX_ACCOUNT_OVERSEAS;
var REGEX_PW = /^[^<>\u4e00-\u9fa5]{4,16}$/;
// 短信验证码
exports.REGEX_PW = REGEX_PW;
var REGEX_CODE = /^\w{4,6}$/;
// 账号组合 _最多3个
exports.REGEX_CODE = REGEX_CODE;
var REGEX_ACCOUNT_MERGE = /^(?=(?:[^_]*_){0,3}[^_]*$)[\w\d_]{5,18}$/;
/**
 * 账号数字开头校验
 * @param param
 */
exports.REGEX_ACCOUNT_MERGE = REGEX_ACCOUNT_MERGE;
var validHeadNum = function validHeadNum(param) {
  var charFirst = param.charAt(0);
  return REGEX_HEAD_NUM.test(charFirst) && !REGEX_NUM.test(param);
};
/**
 * 账号字母开头校验
 * @param param
 */
exports.validHeadNum = validHeadNum;
var validAlpha = function validAlpha(param) {
  var charFirst = param.charAt(0);
  return REGEX_ALPHA.test(charFirst) && !REGEX_ACCOUNT.test(param);
};
exports.validAlpha = validAlpha;
var validAlphaOverseas = function validAlphaOverseas(param) {
  return !REGEX_ACCOUNT_OVERSEAS.test(param);
};
/**
 * 海外校验下划线开头
 * @param param
 */
exports.validAlphaOverseas = validAlphaOverseas;
var validOverseas = function validOverseas(param) {
  var charFirst = param.charAt(0);
  return charFirst !== '_' && !REGEX_HEAD_NUM.test(charFirst) && !REGEX_ALPHA.test(charFirst);
};
/**
 * 账号
 * @param param
 */
exports.validOverseas = validOverseas;
var validAccount = function validAccount(param) {
  var charFirst = param.charAt(0);
  return charFirst !== '_' && !REGEX_HEAD_NUM.test(charFirst) && !REGEX_ALPHA.test(charFirst);
};
exports.validAccount = validAccount;
var validAccountMerge = function validAccountMerge(param) {
  return !REGEX_ACCOUNT_MERGE.test(param);
};
/**
 * 中文校验
 * @param param
 */
exports.validAccountMerge = validAccountMerge;
var validChs = function validChs(param) {
  return REGEX_CHS.test(param);
};
/**
 * 空校验
 * @param param
 */
exports.validChs = validChs;
var validEmpty = function validEmpty(param) {
  return param.trim().length === 0;
};
/**
 * 密码校验
 * @param param
 */
exports.validEmpty = validEmpty;
var validPw = function validPw(param) {
  return !REGEX_PW.test(param);
};
/**
 * 验证码校验
 * @param param
 */
exports.validPw = validPw;
var validCode = function validCode(param) {
  return !REGEX_CODE.test(param);
};
/**
 * 账号规则
 */
exports.validCode = validCode;
var ACCOUNT_RULES = {
  VALID_EMPTY: '账号、密码不能为空',
  VALID_ACCOUNT: '账号需由6-16位字母和数字组合,字母开头',
  VALID_HEAD_NUM: '账号格式错误',
  VALID_ALPHA: '账号需由6-16位字母和数字组合,字母开头',
  VALID_ACCOUNT_MERGE: '账号格式错误',
  VALID_CHS: '账号格式错误，不允许包含中文'
};
exports.ACCOUNT_RULES = ACCOUNT_RULES;
var ACCOUNT_RULES_OVERSEAS = {
  VALID_EMPTY: '账号、密码不能为空',
  VALID_ALPHA_OVERSEAS: '账号需由6-18位字母和数字组合,字母开头',
  VALID_CHS: '账号格式错误，不允许包含中文'
};
/**
 * 密码规则
 */
exports.ACCOUNT_RULES_OVERSEAS = ACCOUNT_RULES_OVERSEAS;
var PW_RULES = {
  VALID_EMPTY: '账号、密码不能为空',
  VALID_PW: '密码需由4-16位字符（除>和<）'
};
/**
 * 验证码规则
 */
exports.PW_RULES = PW_RULES;
var CODE_RULES = {
  VALID_EMPTY: '账号、短信验证码不能为空',
  VALID_CODE: '验证码格式错误'
};
/**
 * 账号规则
 */
exports.CODE_RULES = CODE_RULES;
var CODE_ACCOUNT_RULES = {
  VALID_ACCOUNT: '账号需由6-16位字母和数字组合,字母开头',
  VALID_HEAD_NUM: '账号格式错误',
  VALID_ALPHA: '账号需由6-16位字母和数字组合,字母开头',
  VALID_ACCOUNT_MERGE: '账号格式错误',
  VALID_CHS: '账号格式错误，不允许包含中文',
  VALID_EMPTY: '账号不能为空'
};
/**
 * 校验
 * @param param 校验参数
 * @param rules 规则map
 */
exports.CODE_ACCOUNT_RULES = CODE_ACCOUNT_RULES;
var VALID_RULES = {
  VALID_EMPTY: validEmpty,
  VALID_HEAD_NUM: validHeadNum,
  VALID_ALPHA: validAlpha,
  VALID_ACCOUNT: validAccount,
  VALID_ACCOUNT_MERGE: validAccountMerge,
  VALID_CHS: validChs,
  VALID_PW: validPw,
  VALID_CODE: validCode,
  VALID_OVERSEAS: validOverseas,
  VALID_ALPHA_OVERSEAS: validAlphaOverseas
};
exports.VALID_RULES = VALID_RULES;
var handleValid = function handleValid(param, rules) {
  for (var i in rules) {
    if (VALID_RULES[i](param)) {
      return {
        msg: rules[i],
        valid: false
      };
    }
  }
  return {
    msg: '',
    valid: true
  };
};
exports.handleValid = handleValid;